import React,{ useState, useEffect } from 'react';

import Checkbox from '../../images/hardware-setup/checkbox.png';
import Smile from '../../images/hardware-setup/smilly.png';

function ModemConnectivity() { 
    return (
        <div id="modem-setup-component" className="modem-setup-component modem-connectivity-component">
            <h2>Cable Modem and Connectivity</h2>
            <h4>Your Self-Installation Kit Includes the Following Items:</h4>
            <div className='modem-connectivity-container'>
                <div className='check-item-container'>
                    <img src={ Checkbox } /><span>External High Speed Internet modem and power supply</span>
                </div>
                <div className='check-item-container'>
                    <img src={ Checkbox } /><span>Standard Service Agreement & Acceptable Use Policy</span>
                </div>
                <div className='check-item-container'>
                    <img src={ Checkbox } /><span>Network cable</span>
                </div>
            </div>
            <h4>Psst! Don’t Lose This Kit!</h4>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>Protection:</div>
            <p style={{ fontSize:'0.9rem' }}>Like all sensitive electronic equipment, we recommend the modem be placed on a surge protected power bar.</p>

            <h4 style={{ marginTop: '3rem' }}>Basic Troubleshooting</h4>
            <p style={{ fontSize:'0.9rem' }}>Modems have several lights on the front, which can assist with troubleshooting. Here are some things you may want to check if you are experiencing connectivity issues.</p>

            <div className='troubleshoting-items-container'>
                <div className='troubleshooting-column'>
                    <div className='troubleshhoting-item'>
                        <div className='item-header'>
                            <div className='item-smile-icon'>
                                <img src={ Smile } />
                            </div>
                            <span>The “Power” light is not on/not green</span>
                        </div>
                        
                        <ol>
                            <li>Check that the power adapter cable is securely plugged into the power connector on the modem.</li>
                            <li>Try a different wall plug.</li>
                        </ol>
                    </div>
                    <div className='troubleshhoting-item'>
                        <div className='item-header'>
                            <div className='item-smile-icon'>
                                <img src={ Smile } />
                            </div>
                            <span>The “Online” light is not on/not green or blue</span>
                        </div>
                        
                        <ol>
                            <li>Check to make sure the coaxial cable connections are secure.</li>
                            <li>Unplug the modem for 60 seconds. Power on then wait 10 minutes.</li>
                        </ol>
                    </div>
                </div>
                <div className='troubleshooting-column'>
                    <div className='troubleshhoting-item'>
                        <div className='item-header'>
                            <div className='item-smile-icon'>
                                <img src={ Smile } />
                            </div>
                            <span>The “Link Activity” light is not on/not green or blue</span>
                        </div>
                        
                        <ol>
                            <li>Make sure you are using the Ethernet cable connection and not using the USB cable connection between your modem and computer or router.</li>
                            <li>Confirm that the Ethernet cable is connected properly and securely to the cable modem and to the computer or router.</li>
                            <li>Attempt to use a different Ethernet cable between the modem and computer or router if possible.</li>
                            <li>If connecting the modem to a router, try connecting the modem directly to the computer to see if you can get online. If so, the router may be the cause of the connectivity issue.</li>
                        </ol>
                    </div>
                </div>
                
            </div>


        </div>
    )
}

export default ModemConnectivity